import React from 'react';
import RoutesEnum, { RoutesAriaEnum } from './enums/RoutesEnum';
import Library from '../pages/Library/Library';
import DocumentDetails from '../pages/DocumentDetails/DocumentDetails';
import ReadingList from '../pages/ReadingList/ReadingList';
import Testing from '../pages/Testing/Testing';
import SnapDocumentDetails from '../pages/SnapDocumentDetails/SnapDocumentDetails';
import News from '../pages/News/News';
import NewsArticle from '../pages/NewsArticle/NewsArticle';
import Alerts from '../pages/Alerts/Alerts';

import { CountriesEnum } from '../GlobalContext';

export interface iRoute {
    path: RoutesEnum;
    title: string;
    Component: React.ComponentType<any>;
    aria: RoutesAriaEnum;
    disabledForCountries?: CountriesEnum[];
}

const Routes: iRoute[] = [
    {
        path: RoutesEnum.Home,
        title: '',
        Component: Library,
        aria: RoutesAriaEnum.Library
    },
    {
        path: RoutesEnum.DocumentDetails,
        title: '',
        Component: DocumentDetails,
        aria: RoutesAriaEnum.Document
    },
    {
        path: RoutesEnum.SnapDocumentDetails,
        title: '',
        Component: SnapDocumentDetails,
        aria: RoutesAriaEnum.Document
    },
    {
        path: RoutesEnum.ReadingList,
        title: 'My reading list',
        Component: ReadingList,
        aria: RoutesAriaEnum.ReadingList
    },
    {
        path: RoutesEnum.SharedWithMeList,
        title: 'Shared with me',
        Component: ReadingList,
        aria: RoutesAriaEnum.ReadingList
    },
    {
        path: RoutesEnum.Test,
        title: 'Test page',
        Component: Testing,
        aria: RoutesAriaEnum.Test
    },
    {
        path: RoutesEnum.Alerts,
        title: 'Alerts',
        Component: Alerts,
        aria: RoutesAriaEnum.Alerts,
        disabledForCountries: [CountriesEnum.Global]
    },
    {
        path: RoutesEnum.News,
        title: 'News',
        Component: News,
        aria: RoutesAriaEnum.News,
        disabledForCountries: [CountriesEnum.Global]
    },
    {
        path: RoutesEnum.NewsArticle,
        title: 'News Details',
        Component: NewsArticle,
        aria: RoutesAriaEnum.NewsArticle
    }
];

export function getRoutesByAria(aria: RoutesAriaEnum) {
    return Routes.filter((route) => route.aria === aria);
}

export default Routes;
